var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{class:_vm.buttonClass,attrs:{"size":_vm.size}},[_c('icon',{class:_vm.iconClass,attrs:{"icon":_vm.theIcon,"spin":""}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }